var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement, nothing } from "lit";
import { customElement, query, property } from "lit/decorators.js";
import { styles } from "../styles";
import "../components-container/components-container";
export const defaultBenderLogo = "data:image/svg+xml;base64,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";
/**
 * The bender-top-bar element. Consists of a top ui bar and integrates the components-container.
 *
 * @property {string} appLogo - Path or base64 string of the application logo. If omitted, the default BENDER logo is used.
 * @property {string} appName - Name of the application. It will be displayed next to the application logo.
 * @property {string} claimText - Optional claim text/annotation displayed in the top bar. (A claimText is displayed in POWERSCOUT when a customer uses their own logo)
 * @property {string} logoLinkTarget - Href destination when clicking on the logo.
 * @property {string} appNameLinkTarget - Href destination when clicking on the app name.
 * @property {string} claimTextLinkTarget - Href destination when clicking on the claim text.
 */
let Bar = class Bar extends LitElement {
    constructor() {
        super(...arguments);
        this.appLogo = defaultBenderLogo;
        this.appName = "";
        this.claimText = "";
        this.logoLinkTarget = "#";
        this.appNameLinkTarget = "#";
        this.claimTextLinkTarget = "#";
    }
    render() {
        return html `
      <div class="container">
        <div class="menu-row top-bar">
          <div class="app-logo">
            <a href="${this.logoLinkTarget}">
              <img
                class="top-bar__logo"
                part="top-bar-logo"
                src="${this.appLogo}"
                alt="${this.appName} Logo"
              />
            </a>
            <div class="app-logo-text">
              ${this.appName
            ? html `<a
                    class="app-logo-maintext"
                    href=${this.appNameLinkTarget}
                    >${this.appName}</a
                  >`
            : nothing}
              ${this.claimText
            ? html `<a
                    class="app-logo-subtext"
                    href=${this.claimTextLinkTarget}
                    >${this.claimText}</a
                  >`
            : nothing}
            </div>
          </div>
          <bender-components-container class="menu-items"></bender-components-container>
        </div>
      </div>
    `;
    }
};
Bar.styles = styles;
__decorate([
    property({ type: String })
], Bar.prototype, "appLogo", void 0);
__decorate([
    property({ type: String })
], Bar.prototype, "appName", void 0);
__decorate([
    property({ type: String })
], Bar.prototype, "claimText", void 0);
__decorate([
    property({ type: String })
], Bar.prototype, "logoLinkTarget", void 0);
__decorate([
    property({ type: String })
], Bar.prototype, "appNameLinkTarget", void 0);
__decorate([
    property({ type: String })
], Bar.prototype, "claimTextLinkTarget", void 0);
__decorate([
    query("bender-components-container")
], Bar.prototype, "components", void 0);
Bar = __decorate([
    customElement("bender-top-bar")
], Bar);
export { Bar };
//# sourceMappingURL=top-bar.js.map